









import Vue from 'vue';
import ValidationHelper from '../../../../helpers/ValidationHelper';

export default Vue.extend({
  name: `BoxHeadline`,
  props: {
    color: {
      default: `#fff`,
      type: String,
      validator: prop => ValidationHelper.checkIfStringIsHexColor(prop),
    },
    overview: {
      default: false,
      type: Boolean,
    },
    text: {
      default: ``,
      type: String,
    },
  },
});
